<template>
  <div :class="{sidebar: true, sidebarRight: true, sidebarActive: sidebarActivities.markers }">
    <div class="sidebar-wrap">
      <VerticalExpander text="Markers" type="markers" />
      <div class="sidebar__content" v-if="sidebarActivities.markers">
        <div class="title title--small title-markers">
          Markers
        </div>
        <div class="media__content">
          <Marks />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import VerticalExpander from "../UI/VerticalExpander";
import Marks from "../Marks";

export default {
  computed: {
    ...mapState(["sidebarActivities"])
  },
  methods: {},
  components: {
    VerticalExpander,
    Marks
  }
};
</script>

<style lang="scss" scoped>
  .title-markers {
    margin-bottom: 20px;
  }
</style>
